var map = {
	"./arabic.json": 415,
	"./bulgarian.json": 416,
	"./czech.json": 417,
	"./denmark.json": 418,
	"./english.json": 419,
	"./finnish.json": 420,
	"./greek.json": 421,
	"./indonesian.json": 422,
	"./malay.json": 423,
	"./norwegian.json": 424,
	"./romanian.json": 425,
	"./slovakia.json": 426,
	"./swedish.json": 427,
	"./thai.json": 428
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2452;


//////////////////
// WEBPACK FOOTER
// ./src/locales/mobizone [A-Za-z0-9-_,\s]+\.json$/
// module id = 2452
// module chunks = 0